import type { ClientBuilder } from "api-types/builders/clientBuilderTypes";
import type { ClientLocationPlan } from "api-types/locationPlans/locationPlansResponses";
import type { ClientLocation } from "api-types/locations/locationsResponses";
import { FALLBACK_VALUE } from "common/constants";
import { formatLargeDollars } from "common/utils/formatDollars";
import { shouldDisplayPricing } from "./pricingVisibility";

// Similar to getCommunityPlanPrice but if there is no community we just return the
// base price of the plan

export function getPlanBasePrice(
  communityPlan: Pick<ClientLocationPlan, "basePrice">,
  community?: ClientLocation,
  builder?: ClientBuilder,
  ancestors?: ClientLocation[] | null,
  prefaceLabel?: string,
) {
  const basePrice = formatLargeDollars(communityPlan.basePrice ?? 0);
  if (!community) {
    return basePrice;
  }
  if (builder) {
    return shouldDisplayPricing("communityPlans", community, ancestors, builder)
      ? `${prefaceLabel ? prefaceLabel + " " : ""}${basePrice}`
      : FALLBACK_VALUE;
  }
  if (community?.displayOptionPrices) {
    return `${prefaceLabel ? prefaceLabel + " " : ""}${basePrice}`;
  }
  return FALLBACK_VALUE;
}

export function getCommunityPlanPrice(
  community: ClientLocation | undefined,
  communityPlan: Pick<ClientLocationPlan, "basePrice">,
  prefaceLabel?: string,
  builder?: ClientBuilder,
  ancestors?: ClientLocation[] | null,
) {
  const basePrice = formatLargeDollars(communityPlan.basePrice ?? 0);

  if (builder) {
    return shouldDisplayPricing("communityPlans", community, ancestors, builder)
      ? `${prefaceLabel ? prefaceLabel + " " : ""}${basePrice}`
      : FALLBACK_VALUE;
  }

  if (community?.displayOptionPrices) {
    return `${prefaceLabel ? prefaceLabel + " " : ""}${basePrice}`;
  }
  return FALLBACK_VALUE;
}
